export const List = {
	listItemDefaultBorder: '1px solid transparent',
	listItemHoverBorder: '1px solid var(--epods--color-border-active)',
	listItemTransparentBorder: '1px solid transparent',
	listItemBorderRadius: 'var(--epods--border-radius)',
};
